import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = '/discounts/discount/:discountId/';

type MutationFnType = typeof mutationFn;

interface DTO {
    discountId: string;
}
const mutationFn = ({ discountId }: DTO): Promise<void> => {
    return axios.delete(formatResourcePath(RESOURCE, { discountId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useDeleteDiscount };
